import PropTypes from 'prop-types';
import { explicitNull, or } from 'airbnb-prop-types';
import statsType from './stats';

export const statsInterrogationType = PropTypes.exact({
  title: PropTypes.string.isRequired,
  titleClass: PropTypes.string.isRequired,
  classNames: PropTypes.string.isRequired,
  stats: statsType.isRequired,
});

export const statsObservationType = PropTypes.exact({
  classNames: PropTypes.string.isRequired,
  stats: statsType.isRequired,
});

export const suspectsType = PropTypes.arrayOf(PropTypes.exact({
  imgSrc: PropTypes.string.isRequired,
  correct: or([PropTypes.bool, explicitNull]).isRequired,
}));

export const observationResultsType = PropTypes.exact({
  suspects: suspectsType.isRequired,
});

export const statsTellType = PropTypes.exact({
  classNames: PropTypes.string.isRequired,
  stats: statsType.isRequired,
});

export const observationSignsDetectedType = PropTypes.exact({
  tells: PropTypes.arrayOf(PropTypes.exact({
    imgSrc: PropTypes.string.isRequired,
    questionIndex: PropTypes.number.isRequired,
    tellKey: PropTypes.string.isRequired,
    tellLabel: PropTypes.string.isRequired,
  })),
});
